import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent {
  @Input() fromDate: Date | null = null;
  @Input() toDate: Date | null = null;
  @Input() programs: any[] = [];
  @Input() selectedProgram: string = 'ALL';
  @Output() dateChange = new EventEmitter<{ fromDate: Date | null, toDate: Date | null, selectedProgram: string | null }>();

  onApply() {
    this.dateChange.emit({ fromDate: this.fromDate, toDate: this.toDate, selectedProgram: this.selectedProgram });
  }
}